import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import ArchiveIcon from "@mui/icons-material/Archive";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

// import { components } from "../../../../../Components/Icons/DataTableIcons";
import {
  ThemeProvider,
  Paper,
  Card,
  CardContent,
  Grid,
  Container,
  Box,
  Typography,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import {
  // ActivateIcon,
  // DeactivateIcon,
  // EditIcon,
  MuiDataTableTheme,
  ViewIcon,
} from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import { styled } from "@mui/material/styles";
import Page from "../../../../../Components/Dashboard/Page";
import { poppinsCustomTheme } from "../../../../../Styles/GlobalStyles/PoppinsTheme";
import { PrintButtonIcon } from "../../../../../Components/Icons/DataTableIcons";
import { fShortenNumber } from "../../../../../Utils/formatNumber";
import Iconify from "../../../../../Components/Dashboard/Iconify";
import LoadingOverlay from "react-loading-overlay-ts";
import Searchbox from "../../../../../Components/Dashboard/Searchbox";
import StatusGenerator from "../../../../../Components/StatusGenerator/StatusGenerator";
import CustomFilterSelect from "../../../../../Components/CMLoanStatus/CustomFilterSelect";
import NoTableData from "../../../../../Components/CMLoanStatus/NoTableData";
import ViewCMDialog from "../../../../../Components/CMLoanStatus/ViewCMDialog";
import PrintLoanStatusFormat from "../../../../../Components/CMLoanStatus/PrintLoanStatusFormat";

import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import {
  fetchTotalLoanBeneficiariesDetails,
  fetchAllLoanBeneficiariesLs, // get all, apply search, filters
  fetchDataForPrinting,
  makeRequestLoanStatus,
  fetchPaymentByLoanBeneficiaryId,
  exportLoanBeneficiaries,
  // restoreLoanStatusInitial,
  fetchAllLoansForFilter, // get partners data for the corresponding autocomplete
} from "../../../../../Actions";

const RootStyle = styled(Card)(({ theme, bgcolor = "#FFE2E5" }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(3, 0),
  color: theme.palette.primary.darker,
  backgroundColor: bgcolor,
  borderRadius: "16px",
}));

const IconWrapperStyle = styled("div")(({ theme, bgcolor = "#FA5A7D" }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: "center",
  marginBottom: theme.spacing(2),
  color: "#fff",
  backgroundColor: bgcolor,
}));

const CardTotalPartners = ({ value, title, bgcolor, iconColor, theIcon }) => {
  return (
    <RootStyle bgcolor={bgcolor}>
      <IconWrapperStyle bgcolor={iconColor}>
        <Iconify icon={theIcon} width={22} height={22} />
      </IconWrapperStyle>
      <Typography variant="h5" fontWeight={700} fontSize={"25px"}>
        {fShortenNumber(value)}
      </Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72, fontSize: "12px" }}>
        {title}
      </Typography>
    </RootStyle>
  );
};

const CustomToolbarSelect = () => {
  const handleClickArchive = () => {};
  return (
    <div style={{ marginRight: " 24px" }}>
      <Tooltip title={`Archive Partners`}>
        <IconButton onClick={handleClickArchive}>
          <ArchiveIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

const DownloadIcon = () => {
  const loanStatusReducer = (state) => state.loanStatusReducer;
  const { downloadingExportFile } = useSelector(loanStatusReducer);

  if (downloadingExportFile) {
    return <CircularProgress size={20} />;
  } else {
    return <DescriptionOutlinedIcon />;
  }
};

const ColumnTextStyle = {
  textTransform: "capitalize",
  textAlign: "left",
  color: "#212b36",
  fontSize: "0.875rem",
  fontWeight: 600,
};

const LoanStatus = () => {
  const dispatch = useDispatch();
  const loanStatusReducer = (state) => state.loanStatusReducer;
  const {
    dashboardData,
    allFetchedLoanBeneficiaries,
    dataForPrinting,
    makingRequestLoanStatus,
    fetchingDataForPrinting,
    tableMetaData,
    downloadingExportFile,
    allLoansForFilter,
  } = useSelector(loanStatusReducer);

  const figureColumnStyle = {
    paddingRight: "30px",
    fontSize: "14px",
    fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
  };

  const [proceedWithPrint, setProceedWithPrint] = useState(false);
  const [viewCMDialogIsOpen, setViewCMDialogIsOpen] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    Loan: [], // feeds the autocomplete
    Status: "",
  });
  const [hasUserAppliedFilter, setHasUserAppliedFilter] = useState(false);

  const [filterAutocompleteOptions, setFilterAutocompleteOptions] = useState(
    []
  );

  const [cmLoanStatusTableData, setCMLoanStatusTableData] = useState([]);
  const [formattedDataForPrinting, setFormattedDataForPrinting] = useState([]);
  const [targetLoanBeneficiaryData, setTargetLoanBeneficiaryData] = useState(
    {}
  );
  const [displayWelcomeMessage, setDisplayWelcomeMessage] = useState(true);
  const [tablePaginationData, setTablePaginationData] = useState({
    totalPages: 0,
    pageSize: 10,
    totalCount: 0,
    pageNumber: 1,
    nextPage: 0,
    previousPage: 0,
    firstPage: 0,
    lastPage: 0,
    Search: "",
  });

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const fireFetchAllLoanBeneficiaries = (body = tablePaginationData) => {
    // this fetches all loan beneficiaries
    dispatch(makeRequestLoanStatus());
    dispatch(fetchAllLoanBeneficiariesLs(body));
  };

  const handleSearchChange = (event) => {
    // fires on search change
    setDisplayWelcomeMessage(false);
    const newSearchText = event.target.value;
    // setSearchText(newSearchText);
    setTablePaginationData({
      ...tablePaginationData,
      Search: newSearchText,
      FilterOptions: filterOptions,
    });
    fireFetchAllLoanBeneficiaries({
      // bad logic here, doesn't follow DRY principle
      ...tablePaginationData,
      Search: newSearchText,
      FilterOptions: filterOptions,
    });
  };

  const handleAutocompleteChange = (event, newValue) => {
    setHasUserAppliedFilter(true);
    setFilterOptions({
      ...filterOptions,
      Loan: newValue,
    });
  };

  const handleOpenCMDialog = (loanBeneficiaryId) => {
    const targetLB = allFetchedLoanBeneficiaries.find(
      (lb) => lb.id === loanBeneficiaryId
    );
    dispatch(
      fetchPaymentByLoanBeneficiaryId({
        loanBeneficiaryId: loanBeneficiaryId,
      })
    );
    setTargetLoanBeneficiaryData(targetLB);
    setViewCMDialogIsOpen(true);
  };

  const handleCloseCMDialog = () => {
    setViewCMDialogIsOpen(false);
    setTargetLoanBeneficiaryData({});
  };

  const handlePrint = () => {
    dispatch(fetchDataForPrinting());
    setProceedWithPrint(true);
  };

  const dashboardCards = [
    {
      title: "Total Loan Beneficiary",
      value: dashboardData.totalLoanBeneficiaries,
      icon: "null",
      bgcolor: "#C8E7FD",
      iconColor: "#0095FF",
      theIcon: "fluent:people-team-16-filled",
      id: "totalLoanBeneficiary",
    },
    {
      title: "Total Complete Loan Payments",
      value: dashboardData?.totalPaidLoanBeneficiaries,
      icon: "null",
      bgcolor: "#AFE0C6",
      iconColor: "#016C34",
      theIcon: "fluent:people-checkmark-16-filled",
      id: "totalCompleteLoanPayments",
    },
    {
      title: "Total Incomplete Loan Payments",
      value: dashboardData?.totalOwingLoanBeneficiaries,
      icon: "null",
      bgcolor: "#FFE2E5",
      iconColor: "#DC2626",
      theIcon: "fluent:people-team-delete-32-filled",
      id: "totalIncompleteLoanPayments",
    },
  ];

  const filters = [
    {
      name: "Loan Provider",
    },
    {
      name: "Payment Status",
      component: "select",
      options: [
        {
          value: 0,
          label: "Owing",
        },
        {
          value: 1,
          label: "Paid",
        },
      ],
      stateHolder: filterOptions.Status,

      setFilterStateHolder: (newValue) => {
        setHasUserAppliedFilter(true);
        setFilterOptions({
          ...filterOptions,
          Status: newValue,
        });
      },
    },
  ];

  const columns = [
    {
      name: "cmName",
      label: "Corps Member",
      options: {
        setCellProps: () => ({
          style: { minWidth: "210px", paddingLeft: "24px" },
        }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography
              style={{ paddingLeft: "24px" }}
              sx={ColumnTextStyle}
              key={index}
            >
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "stateCode",
      label: "State Code",
      options: {
        setCellProps: () => ({ style: { minWidth: "110px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value;
        },
      },
    },
    {
      name: "loan",
      label: "Loan",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "loanAmount",
      label: "Loan Amount (₦)",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          let formattedNumber = new Intl.NumberFormat().format(value);
          // return `₦ ${formattedNumber}`;
          return (
            <Typography
              align="right"
              style={figureColumnStyle}
            >{`₦ ${formattedNumber}`}</Typography>
          );
        },
      },
    },

    {
      name: "amountPaidFigure",
      label: "Amount Paid (₦)",
      options: {
        filter: true,
        setCellProps: () => ({ style: { minWidth: "140px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          let formattedNumber = new Intl.NumberFormat().format(value);
          return (
            <Typography
              align="right"
              style={figureColumnStyle}
            >{`₦ ${formattedNumber}`}</Typography>
          );
        },
      },
    },
    {
      name: "amountPaidPercentage",
      label: "Amount Paid (%)",
      options: {
        filter: true,
        setCellProps: () => ({ style: { minWidth: "140px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <Typography
              align="right"
              style={figureColumnStyle}
            >{`${value}%`}</Typography>
          );
        },
      },
    },
    {
      name: "loanBalance",
      label: "Loan Balance (₦)",
      options: {
        filter: true,
        setCellProps: () => ({ style: { minWidth: "140px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          let formattedNumber = new Intl.NumberFormat().format(value);
          return (
            <Typography
              align="right"
              style={figureColumnStyle}
            >{`₦ ${formattedNumber}`}</Typography>
          );
        },
      },
    },
    {
      name: "expiryDate",
      label: "Expiry Date",
      options: {
        filter: true,
        setCellProps: () => ({ style: { minWidth: "140px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD/MM/YYYY");
        },
      },
    },
    {
      name: "paymentStatus",
      label: "Status",
      options: {
        sort: false,
        setCellProps: () => ({ style: { minWidth: "120px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          if (value >= 0 && value < 100) {
            return <StatusGenerator statusText="Owing" variant="redFilled" />;
          } else if (value > 99) {
            return <StatusGenerator statusText="Paid" variant="greenFilled" />;
          } else return <></>;
        },
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value) => {
          // value is loan beneficiary (CM) id
          return (
            <>
              <Tooltip title={"View Corps Member"}>
                <IconButton
                  size="small"
                  onClick={() => {
                    handleOpenCMDialog(value);
                  }}
                >
                  <ViewIcon icon="material-symbols:visibility-outline" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  const options = {
    // count: tablePaginationData.totalCount,
    count: tablePaginationData.totalCount,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    disableRipple: true,
    elevation: 0,
    filter: false,
    filterType: "dropdown",
    fixedHeader: true,
    jumpToPage: true,
    page: tablePaginationData.pageNumber - 1,
    pagination: true,
    print: false,

    responsive: "standard",
    rowsPerPageOptions: [10],
    search: false,
    selectableRows: "none",
    serverSide: true,
    tableBodyHeight: "600px",
    tableBodyMaxHeight: "1000px",
    onDownload: () => {
      if (!downloadingExportFile) {
        dispatch(exportLoanBeneficiaries());
        return false;
      } else return false;
    },
    customToolbar: () => {
      return (
        <>
          <Tooltip title="Print All Loan Beneficiaries">
            <IconButton
              onClick={() => {
                handlePrint();
              }}
            >
              {fetchingDataForPrinting ? (
                <CircularProgress size={24} />
              ) : (
                <PrintButtonIcon />
              )}
            </IconButton>
          </Tooltip>
        </>
      );
    },
    customToolbarSelect: () => <CustomToolbarSelect />,

    onChangePage: (currentPage) => {
      document
        .getElementById("totalLoanBeneficiary")
        .scrollIntoView({ behavior: "smooth" });
      setTablePaginationData({
        ...tablePaginationData,
        pageNumber: currentPage + 1,
      });
      fireFetchAllLoanBeneficiaries({
        // rewrite this, should not pass obj here, set the state instead
        // reset search text on page change
        PageNumber: currentPage + 1,
        PageSize: tablePaginationData.pageSize,
        Search: "",
      });

      dispatch(makeRequestLoanStatus());
    },

    textLabels: {
      body: {
        noMatch:
          !makingRequestLoanStatus && // if we are not making a request
          allFetchedLoanBeneficiaries?.length < 1 && // if no data available
          (displayWelcomeMessage === true ? ( // 404 event check
            hasUserAppliedFilter === false ? ( // has filter been applied check
              <NoTableData
                fetchAllDataHandler={fireFetchAllLoanBeneficiaries}
              />
            ) : (
              <>No Matching Data Found</>
            )
          ) : (
            <>No Matching Data Found</>
          )),
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      toolbar: {
        search: "Search",
        downloadCsv: "Download sheet",
        print: "Print page",
        viewColumns: "View columns",
        filterTable: "Filter table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  const components = {
    icons: {
      DownloadIcon,
    },
  };

  useEffect(() => {
    if (makingRequestLoanStatus === false) {
      dispatch(fetchTotalLoanBeneficiariesDetails(tablePaginationData)); // fetch dashboard data
    }
    dispatch(fetchAllLoansForFilter());
  }, [makingRequestLoanStatus]);

  useEffect(() => {
    if (allFetchedLoanBeneficiaries) {
      let tableData = [];

      allFetchedLoanBeneficiaries.map((ben) => {
        let benObject = {
          cmName: ben.cmName,
          stateCode: ben.cmStateCode,
          loan: ben.loan.name,
          loanAmount: ben.loan.amount,
          amountPaidFigure: ben.totalAmountPaid,
          amountPaidPercentage: ben.totalAmountPaidInPercent,
          loanBalance: ben.loan.amount - ben.totalAmountPaid,
          expiryDate: ben.loan.expiryDate,
          paymentStatus: ben.totalAmountPaidInPercent,
          actions: ben.id,
        };
        tableData.push(benObject);
      });

      setCMLoanStatusTableData(tableData);
    }
  }, [allFetchedLoanBeneficiaries]);

  useEffect(() => {
    // processes data for printing
    if (dataForPrinting.length > 0) {
      let tableData = [];

      dataForPrinting.map((ben) => {
        let benObject = {
          cmName: ben.cmName,
          stateCode: ben.cmStateCode,
          loan: ben.loan.name,
          amountPaidFigure: ben.totalAmountPaid,
          amountPaidPercentage: ben.totalAmountPaidInPercent,
          expiryDate: ben.loan.expiryDate,
          paymentStatus: ben.totalAmountPaidInPercent,
          actions: ben.id,
        };
        tableData.push(benObject);
      });

      setFormattedDataForPrinting(tableData);
    }
  }, [dataForPrinting]);

  useEffect(() => {
    // triggers the print window
    if (formattedDataForPrinting.length > 0 && proceedWithPrint === true) {
      var iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.srcdoc = document.getElementById("print-template").innerHTML;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
      setProceedWithPrint(false);
    }
  }, [formattedDataForPrinting]);

  useEffect(() => {
    if (Object.keys(tableMetaData).length > 0) {
      setTablePaginationData({
        ...tableMetaData,
        Search: tablePaginationData.Search,
        FilterOptions: filterOptions,
      });
    }
  }, [tableMetaData]);

  useEffect(() => {
    if (hasUserAppliedFilter === true) {
      fireFetchAllLoanBeneficiaries({
        ...tablePaginationData,
        FilterOptions: filterOptions,
      });
    }
  }, [filterOptions]);

  useEffect(() => {
    let formattedLoansData = [];

    allLoansForFilter.map((loan) => {
      formattedLoansData.push({
        label: loan.name,
        value: `${loan.id}`,
      });
    });

    setFilterAutocompleteOptions(formattedLoansData);
  }, [allLoansForFilter]);

  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Page title="SAED | CM Loan Status">
        <Container maxWidth="x1">
          <Box sx={{ pb: 2 }}>
            <Typography
              variant="h5"
              style={{ fontWeight: 600, color: "#212B36" }}
            >
              Loan Management &gt;
              <span
                style={{
                  fontWeight: 100,
                  fontSize: "1.09rem",
                  color: "#909090",
                  marginLeft: "10px",
                }}
              >
                Track Loan Beneficiary
              </span>
            </Typography>
          </Box>
          <Box sx={{ pb: 2 }}>
            <Grid container spacing={3}>
              {dashboardCards.map((card) => {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md
                    key={`${card.title}-${card.value}`}
                    id={card.id}
                  >
                    <CardTotalPartners
                      value={card.value}
                      title={card.title}
                      bgcolor={card.bgcolor}
                      iconColor={card.iconColor}
                      theIcon={card.theIcon}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box>
                <Paper
                  sx={{
                    boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                    borderRadius: "20px",
                  }}
                >
                  <Card
                    elevation={0}
                    sx={{ padding: "0px !important", borderRadius: "20px" }}
                  >
                    <CardContent sx={{ padding: "0px !important" }}>
                      <ThemeProvider theme={MuiDataTableTheme}>
                        <LoadingOverlay
                          active={makingRequestLoanStatus}
                          styles={{
                            overlay: (base) => ({
                              ...base,
                              background: "rgba(0, 0, 0, 0.15)",
                            }),
                          }}
                          spinner
                          text="Fetching Data for You..."
                        >
                          <MUIDataTable
                            title={
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={10}
                                justifyContent="space-between"
                              >
                                <Searchbox
                                  value={tablePaginationData.Search}
                                  onChange={handleSearchChange}
                                  width={"4rem"}
                                  hoverWidth={"5rem"}
                                />
                                <Grid
                                  container
                                  direction={"row"}
                                  spacing={4}
                                  style={{
                                    justifyContent: "flex-end",
                                    marginTop: "-10px",
                                  }}
                                >
                                  {filters.map((filter) => {
                                    return filter.component === "select" ? (
                                      <CustomFilterSelect
                                        key={filter.component}
                                        filterName={filter.name}
                                        filterOptions={filter.options}
                                        filterStateHolder={filter.stateHolder}
                                        setFilterStateHolder={
                                          filter.setFilterStateHolder
                                        }
                                      />
                                    ) : (
                                      <div style={{ marginTop: "-3px" }}>
                                        <Autocomplete
                                          multiple
                                          disableCloseOnSelect
                                          sx={{
                                            maxWidth: "320px",
                                            minWidth: "200px",
                                          }}
                                          limitTags={1}
                                          id="checkboxes-tags-demo"
                                          value={filterOptions.Loan}
                                          onChange={handleAutocompleteChange}
                                          options={filterAutocompleteOptions}
                                          getOptionLabel={(option) =>
                                            option.label
                                          }
                                          isOptionEqualToValue={(
                                            option,
                                            value
                                          ) => {
                                            return option.value === value.value;
                                          }}
                                          renderOption={(
                                            props,
                                            option,
                                            { selected }
                                          ) => (
                                            <li {...props}>
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{
                                                  marginRight: 8,
                                                  // minWidth: "150px",
                                                }}
                                                checked={selected}
                                              />
                                              {option.label}
                                            </li>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label="Loan"
                                              variant="standard"
                                              // style={{ width: 300 }}
                                              // style={{ minWidth: 130 }}
                                              // placeholder="Loan"
                                            />
                                          )}
                                        />
                                      </div>
                                    );
                                  })}
                                </Grid>
                              </Box>
                            }
                            columns={columns}
                            options={options}
                            components={components}
                            data={cmLoanStatusTableData}
                          />
                        </LoadingOverlay>
                      </ThemeProvider>
                    </CardContent>
                  </Card>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Container>
        <ViewCMDialog
          isOpen={viewCMDialogIsOpen}
          onCloseHandler={handleCloseCMDialog}
          loanBeneficiaryData={targetLoanBeneficiaryData}
          tablePaginationData={tablePaginationData}
        />
        <div id="print-template" style={{ display: "none" }}>
          <PrintLoanStatusFormat data={formattedDataForPrinting} />
        </div>
      </Page>
    </ThemeProvider>
  );
};

export default LoanStatus;
